import { enqueueSnackbar } from 'notistack';
import { useState } from 'react';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { COMMONTYPES } from '../../TYPES/event.types';
import { Button, Spacer } from '../../components/atoms';
import { InputField } from '../../components/atoms/InputField/InputField';
import { resetPassword } from '../../network/services/auth';
import { validators } from '../../utils/validator';
import { AuthContainer, InputCon, extraStylesInput } from './styles';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const handleChange = (e: COMMONTYPES['inputChange']) => {
    setEmail(e.target.value);
    const error = validators.email(e.target.value) || '';
    setError(error);
  };

  const { mutateAsync, isLoading } = useMutation({ mutationFn: resetPassword });

  const navigate = useNavigate();

  const _requestOtp = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();

    try {
      const { data } = await mutateAsync({ email });
      const status = String(data?.status ?? '').toLowerCase();
      const message = data?.message || data?.description || 'Check your email for the reset code.';
      if (status === 'success') {
        enqueueSnackbar(message, { variant: 'success' });
        navigate(`/otp/forgot-password/${encodeURIComponent(email)}`);
        return;
      }
      enqueueSnackbar(message, { variant: 'error' });
    } catch (error: any) {
      const message = error?.response?.data?.message || error?.response?.data?.description || 'The reset code was not sent.';
      enqueueSnackbar(message, { variant: 'error' });
    }
  };

  const disabled = !email || !!validators.email(email);

  return (
    <AuthContainer>
      <h1>Please Enter your email address</h1>
      <p className="option">an otp verification will be sent to your email</p>
      <form>
        <InputCon>
          <span>Email Address</span>
          <InputField
            type="email"
            name="email"
            value={email}
            onChange={handleChange}
            placeholder="example@mail.com"
            extraStyles={extraStylesInput}
            required={true}
            error={error}
          />
        </InputCon>
        <Spacer height={'3.5rem'} />
        <div className="buttonContainer">
          <Button
            // extraStyles={bottonStyle}
            isLoading={isLoading}
            type="submit"
            onClick={_requestOtp}
            disabled={disabled}>
            Reset
          </Button>
        </div>
      </form>
    </AuthContainer>
  );
};

export default ForgotPassword;
